// 设置Cookie


export const setCookie = (name, value, days) => {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${date.toUTCString()};path=/`
}

// 获取Cookie
export const getCookie = (name) => {
    const cookie = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')
    return cookie ? decodeURIComponent(cookie.pop()) : null
}

// 删除Cookie
export const removeCookie = (name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`
}
